import React, { useEffect, useRef, useState } from "react";
import '../../../src/pages/Website/webStyle.css'
import WebsiteNavbar from "./Navbar";
import Footer from "./footer";
import { getData } from "src/webService/webService";
import { toast } from "react-toastify";
import { Box, Button, Dialog, DialogContent } from "@mui/material";
import hanger from '../../components/images/hanger.png';
import Loader from "../Loader/Loader";
import user from '../../components/icons/user-dark.png';
import location from '../../components/icons/location.png';
import Iconify from "src/components/iconify";
import whatsapp from '../../components/icons/whatsapp-32px.png';
import ViewSeller from "./viewSeller";

export default function ViewSellerList({ id, handleViewSellerList, advertisement }) {

    const [name, setName] = useState('');
    const Token = sessionStorage.getItem('Token');
    const [loading, setLoading] = useState(false);
    const [sellerViewList, setSellerViewList] = useState([]);
    const [show, setShow] = useState(true);
    const [sellerId, setSellerId] = useState('');
    const [open, setOpen] = useState(true);
    const [showSkip, setShowSkip] = useState(false);
    const skipTimerRef = useRef(null);
    const [skipCountdown, setSkipCountdown] = useState(5);
    const [totalPages, setTotalPages] = useState(1)
    const [TotalItems, setTotalItems] = useState(null);
    const [limit, setLimit] = useState(5);

    const handleClose = () => {
        clearTimeout(skipTimerRef.current);
        setOpen(false);
    };

    useEffect(() => {
        let countdownInterval;

        if (open) {
            setShowSkip(false);
            setSkipCountdown(5);

            countdownInterval = setInterval(() => {
                setSkipCountdown((prev) => {
                    if (prev === 1) {
                        clearInterval(countdownInterval);
                        setShowSkip(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => clearInterval(countdownInterval);
    }, [open]);

    const viewSellerListById = async (page) => {
        debugger;
        setLoading(true);
        const params = id
        const pagination = limit


        try {
            const res = await getData(`buyer/sellers?category=${params}&per_page=${pagination}`, null, Token);
            if (res.status === 200) {
                console.log(res.data.data, "res.data");
                setSellerViewList(res.data.data);
                setTotalItems(res?.data?.total);
                setTotalPages(res?.data?.last_page);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        viewSellerListById(1);
    }, [id, limit]);

    const handleNextPage = () => {
        if (limit > totalPages) {
            setLimit(limit + 5)
        }
    };

    const handleViewSeller = (id) => {
        setShow(!show);
        setSellerId(id);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [show]);

    return (
        <div>
            {show ? (

                <div>
                    <div className="Banner">
                        <div className="w-50 d-flex justify-content-center align-items-center banner-title">
                            <h1>Seller List</h1>
                        </div>
                    </div>

                    {loading ? (
                        <Loader />
                    ) : (
                        <div>
                            <div className="d-flex justify-content-center mt-5">
                                <p className="clip-path" onClick={handleViewSellerList}>Categories</p>
                                <p className="clip-path" style={{ background: '#f0c99b' }}>Seller View</p>
                            </div>
                            <div className="container mt-3">
                                <div className="row seller-listing">
                                    {sellerViewList?.length === 0 ? (
                                        <div>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <img src={hanger} width='10%' />
                                            </div>
                                            <h5 className="text-center">No brands are currently available. <br/>The process is underway, and brands will be displayed shortly.</h5>
                                            <div className="d-flex justify-content-center align-items-center mt-4">
                                                <Button sx={{ margin: '0 auto' }} onClick={handleViewSellerList} variant="outlined">Back</Button>
                                            </div>
                                        </div>
                                    ) : (
                                        sellerViewList.map((item, index) => (
                                            <div className="col-lg-6" key={index}>
                                                <div className='sellerCardLayout' onClick={() => handleViewSeller(item?._id)}>
                                                    <div className="w-35">
                                                        <img className="sellerCardLayoutImg" src={item?.profile_picture} />
                                                    </div>
                                                    <div className="d-flex w-65">
                                                        <div>
                                                            <div className="d-flex">
                                                                <h4 style={{ fontWeight: '600' }} className='pt-2 pb-1 pointer'>{item?.name}</h4>
                                                            </div>
                                                            {/* <div className="d-flex align-items-center">
                                                     <div className="d-flex justify-content-center align-items-center" style={{ width: '7%' }}>
                                                         <img width='100%' src={location} />
                                                     </div> */}
                                                            <p style={{ fontWeight: '600', fontSize: '14px' }} className='pt-0 mb-0'><Iconify icon="eva:pin-outline" style={{ width: '16px' }} /> {item?.location ? item?.location : 'No Location Found :('}</p>
                                                            {/* </div> */}
                                                            <div>
                                                                <p className="-about" style={{ fontSize: '14px', marginTop: '12px' }}><Iconify icon="eva:alert-circle-outline" style={{ width: '16px' }} /> {item?.aboutus}</p>
                                                            </div>
                                                            {/* <div className="mt-3 d-flex">
                                                     <div>
                                                         <Button variant="contained" style={{ background: '#058a07', boxShadow: 'none' }} startIcon={<Iconify icon="eva:phone-outline" />} className="d-flex align-items-center">
                                                             +91 9988776655
                                                         </Button>
                                                     </div>
                                                     <div style={{ marginLeft: '12px' }}>
                                                         <Button variant="outlined" className="d-flex align-items-center" style={{ padding: '5px 10px' }}>
                                                             <div className="d-flex justify-content-center align-items-center" style={{ width: '24%', marginRight: '10px' }}>
                                                                 <img width='100%' src={whatsapp} />
                                                             </div>
                                                             Whatsapp
                                                         </Button>
                                                     </div>
                                                 </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}

                                    <div className="d-flex justify-content-center mt-5 align-items-center">
                                        <Button variant="contained" className='Button' onClick={handleNextPage}
                                            disabled={TotalItems <= limit}>Load More</Button>
                                    </div>
                                </div>
                            </div>
                            {advertisement ? (
                                <Dialog open={open} maxWidth="md">
                                    <DialogContent sx={{ position: 'relative', p: 0 }}>
                                        <Box position="relative">
                                            {advertisement.split('.').pop().toLowerCase() === 'mp4' ? (
                                                <video
                                                    width="100%"
                                                    autoPlay
                                                    controls
                                                    // onPlay={handleVideoPlay}
                                                    onPlay={() => { }}
                                                    style={{ borderRadius: '8px' }}
                                                >
                                                    <source src={advertisement} />
                                                </video>
                                            ) : (
                                                <img
                                                    src={advertisement}
                                                    alt="Advertisement"
                                                    style={{ width: '100%', borderRadius: '8px' }}
                                                />
                                            )}

                                            {showSkip ? (
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    onClick={handleClose}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 16,
                                                        right: 16,
                                                        backgroundColor: 'rgba(0,0,0,0.6)',
                                                        color: '#fff',
                                                        px: 2,
                                                        py: 1,
                                                        borderRadius: '8px',
                                                        fontSize: '14px',
                                                    }}
                                                >
                                                    Skip
                                                </Button>
                                            ) : (
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 16,
                                                        right: 16,
                                                        backgroundColor: 'rgba(0,0,0,0.6)',
                                                        color: '#fff',
                                                        px: 2,
                                                        py: 1,
                                                        borderRadius: '8px',
                                                        fontSize: '14px',
                                                    }}
                                                >
                                                    Skip in {skipCountdown}...
                                                </Box>
                                            )}
                                        </Box>
                                    </DialogContent>
                                </Dialog>
                            ) : null}
                        </div>
                    )}
                </div>
            ) : (
                <ViewSeller id={sellerId} handleViewSeller={handleViewSeller} handleViewSellerList={handleViewSellerList} />
            )
            }
        </div>
    )
}